import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-de8bae4c")

_pushScopeId("data-v-de8bae4c")
const _hoisted_1 = { class: "user_info" }
const _hoisted_2 = {
  key: 0,
  class: "not_login_avatar"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "content_wrap" }
const _hoisted_5 = { class: "user_name" }
const _hoisted_6 = { class: "text_wrap flex_start_center" }
const _hoisted_7 = {
  key: 0,
  class: "flex_start_center"
}
const _hoisted_8 = {
  key: 0,
  class: "super_desc"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "super_desc_title" }, [
  /*#__PURE__*/_createVNode("span", null, "【可牛超级会员】"),
  /*#__PURE__*/_createTextVNode("享有以下会员权益 ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("项")
const _hoisted_11 = {
  key: 1,
  class: "single_and_super_box"
}
const _hoisted_12 = { class: "flex_start_center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "member_text" }, "可牛超级会员:", -1)
const _hoisted_14 = {
  key: 0,
  class: "flex_start_center mt_14"
}
const _hoisted_15 = { class: "member_text" }
const _hoisted_16 = {
  key: 0,
  class: "single_desc"
}
const _hoisted_17 = { class: "single_desc_title" }
const _hoisted_18 = { class: "flex_end_center" }
const _hoisted_19 = {
  key: 1,
  class: "single_and_super_box"
}
const _hoisted_20 = { class: "flex_start_center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "member_text" }, "可牛超级会员:", -1)
const _hoisted_22 = {
  key: 0,
  class: "flex_start_center mt_14"
}
const _hoisted_23 = { class: "member_text" }
const _hoisted_24 = { class: "head_text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UserInfoDetail = _resolveComponent("UserInfoDetail")!

  return (_openBlock(), _createBlock("div", {
    class: ['wrapper', _ctx.heightClass]
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "avatar_wrap",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openUserDetail && _ctx.openUserDetail(...args)))
      }, [
        (!_ctx.viewModel.isLogin || !_ctx.viewModel.avatar)
          ? (_openBlock(), _createBlock("div", _hoisted_2))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("img", {
                src: _ctx.viewModel.avatar,
                class: "avatar",
                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.errorImg && _ctx.errorImg(...args)))
              }, null, 40, ["src"]),
              _createVNode("span", {
                class: ["avatar_icon", { is_vip: _ctx.viewModel.isVip }]
              }, null, 2)
            ]))
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.viewModel.isLogin ? _ctx.viewModel.nickname : "未登录"), 1),
          (_ctx.viewModel.isLogin)
            ? (_openBlock(), _createBlock("span", {
                key: 0,
                class: ["login_icon", _ctx.loginTypeClass]
              }, null, 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.viewModel.isLogin)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("div", {
                  class: ['super_member_box', { is_super_member: _ctx.viewModel.isKeniuSuperMember }]
                }, [
                  (!_ctx.viewModel.isVip)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.viewModel.superMemberInterestList, (p, pIdx) => {
                            return (_openBlock(), _createBlock("li", {
                              key: pIdx,
                              class: "flex_start_center"
                            }, [
                              _createVNode("img", {
                                src: p.img
                              }, null, 8, ["src"]),
                              _createVNode("span", null, [
                                _createTextVNode(_toDisplayString(p.label) + "：", 1),
                                _createVNode("b", null, _toDisplayString(p.num), 1),
                                _hoisted_10
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("i", {
                            class: ['no_super_member', { is_super_member: _ctx.viewModel.isKeniuSuperMember }]
                          }, null, 2),
                          _hoisted_13,
                          _createVNode("span", null, _toDisplayString(_ctx.memberInterestDateText('super')), 1)
                        ]),
                        (!_ctx.viewModel.isKeniuSuperDiamondMember)
                          ? (_openBlock(), _createBlock("div", _hoisted_14, [
                              _createVNode("i", {
                                class: ['no_single_member', { is_single_member: _ctx.viewModel.isSingleMember }]
                              }, null, 2),
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.viewModel.title) + "会员:", 1),
                              _createVNode("span", null, _toDisplayString(_ctx.memberInterestDateText('single')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ], 2),
                _createVNode("div", {
                  class: ['single_member_box', { is_single_member: _ctx.viewModel.isSingleMember }]
                }, [
                  (!_ctx.viewModel.isVip)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, "【" + _toDisplayString(_ctx.viewModel.title) + "会员】", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.viewModel.memberInterestDesc) + " ", 1),
                        _createVNode("div", _hoisted_18, [
                          (_ctx.viewModel.productId !== '105')
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                class: "query_text",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.seeInterest && _ctx.seeInterest(...args)))
                              }, "查看详情"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("i", {
                            class: ['no_super_member', { is_super_member: _ctx.viewModel.isKeniuSuperMember }]
                          }, null, 2),
                          _hoisted_21,
                          _createVNode("span", null, _toDisplayString(_ctx.memberInterestDateText('super')), 1)
                        ]),
                        (!_ctx.viewModel.isKeniuSuperDiamondMember)
                          ? (_openBlock(), _createBlock("div", _hoisted_22, [
                              _createVNode("i", {
                                class: ['no_single_member', { is_single_member: _ctx.viewModel.isSingleMember }]
                              }, null, 2),
                              _createVNode("span", _hoisted_23, _toDisplayString(_ctx.viewModel.title) + "会员:", 1),
                              _createVNode("span", null, _toDisplayString(_ctx.memberInterestDateText('single')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createVNode("span", _hoisted_24, _toDisplayString(_ctx.headText), 1),
          (!_ctx.viewModel.isVip && _ctx.viewModel.isLogin)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: "common_btn renew_btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewInterest && _ctx.viewInterest(...args)))
              }, " 查看权益 "))
            : _createCommentVNode("", true),
          (!_ctx.isKoutuMemberCenter && _ctx.viewModel.isKeniuSuperNormalMember && !_ctx.viewModel.keniuSuperNormalMemberInfo?.is_continuous)
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                class: "common_btn renew_btn",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickRenew && _ctx.clickRenew(...args)))
              }, " 续费 "))
            : (!_ctx.isKoutuMemberCenter && _ctx.viewModel.isSingleMember)
              ? (_openBlock(), _createBlock("button", {
                  key: 3,
                  class: "common_btn renew_btn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickRenew && _ctx.clickRenew(...args)))
                }, " 升级超级会员 "))
              : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.viewModel.isLogin)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "common_btn login_btn",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickLogin && _ctx.clickLogin(...args)))
          }, " 立即登录 "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.viewModel.detailVisible)
          ? (_openBlock(), _createBlock(_component_UserInfoDetail, {
              key: 0,
              onSuccess: _ctx.modalSuccess,
              onCancel: _ctx.modalCancel
            }, null, 8, ["onSuccess", "onCancel"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
})